import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useNavigate from '@shared/useNavigate';
import { useDispatch } from 'react-redux';
import { MarketSlug } from '@root/types';
import ListingSearchCriteria from './Criteria/ListingSearchCriteria';

interface RouteParams {
  marketSlug: MarketSlug | 'custom';
}

type Options = {
  onUrlChange: (criteria: ListingSearchCriteria) => void;
};

const useListingSearchCriteria = (options: Partial<Options> = {}) => {
  const { marketSlug } = useParams<RouteParams>();
  const { search: queryString } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const criteria = new ListingSearchCriteria({ queryString, marketSlug, navigate, dispatch });

  useEffect(() => {
    if (options.onUrlChange) options.onUrlChange(criteria);
    // FIXME: Either add the exhaustive deps or delete this line
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString, marketSlug]);

  return criteria;
};

export default useListingSearchCriteria;
